export type NavScope = 'ATU2_2' | 'COMMON' | 'US' | 'KR';

export interface NavItem {
  to: string;
  label: string;
  marker: string;
  scope: NavScope;
}

export const navItems: NavItem[] = [
  { to: '/atu2-lab-fable', label: '2.0 운영 판단', marker: '2', scope: 'ATU2_2' },
  { to: '/atu2-lab', label: '2.0 기술 상세', marker: 'T', scope: 'ATU2_2' },
  { to: '/system-overview', label: '새 시스템 현황', marker: 'N', scope: 'COMMON' },
  { to: '/dashboard', label: '대시보드', marker: 'D', scope: 'COMMON' },
  { to: '/operations', label: '운영 관제', marker: 'O', scope: 'COMMON' },
  { to: '/analyst-learning', label: 'Shadow 관찰', marker: 'A', scope: 'COMMON' },
  { to: '/loss-structure', label: '손실 구조', marker: 'L', scope: 'US' },
  { to: '/checklist', label: 'Pre-Live 체크리스트', marker: 'K', scope: 'COMMON' },
  { to: '/performance', label: '운영 성과', marker: 'P', scope: 'COMMON' },
  { to: '/strategy-execution', label: '전략 실행', marker: 'S', scope: 'COMMON' },
  { to: '/history', label: '매매 이력', marker: 'H', scope: 'COMMON' },
  { to: '/reports', label: '일일 리포트', marker: 'R', scope: 'COMMON' },
  { to: '/backtest', label: '백테스트', marker: 'B', scope: 'COMMON' },
  { to: '/strategy-settings', label: '전략/리스크 설정', marker: 'G', scope: 'COMMON' },
  { to: '/settings', label: '연동/보안 설정', marker: 'C', scope: 'COMMON' },
];

export const navGroups: { scope: NavScope; label: string }[] = [
  { scope: 'ATU2_2', label: 'ATU2 2.0' },
  { scope: 'COMMON', label: '공통 운영' },
  { scope: 'US', label: '미국장 / Toss' },
  { scope: 'KR', label: '국내장 / Toss' },
];
